/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_05_Detail_Amateur_1_HeadingInputs */

const en_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What changes at your home course`)
};

const es_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué cambia en tu campo local`)
};

const de_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was sich an Ihrem Heimkurs ändert`)
};

const zh_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你常去的球场上会有什么改变`)
};

const ar_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما يتغير في ملعبك المحلي`)
};

const fr_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce qui change sur votre parcours habituel`)
};

const vi_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều gì thay đổi trên sân bạn thường chơi`)
};

const sw_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinachobadilika katika uwanja wako wa nyumbani`)
};

const th_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อะไรเปลี่ยนไปในสนามประจำของคุณ`)
};

const bs_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šta se mijenja na tvom lokalnom terenu`)
};

const ja_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホームコースで変わること`)
};

const ko_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`홈 코스에서 달라지는 것`)
};

const pt_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que muda no seu campo de sempre`)
};

const it_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che cosa cambia sul tuo campo abituale`)
};

const sv_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad som förändras på din hemmabana`)
};

const nl_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat er verandert op je thuisbaan`)
};

const da_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad der ændrer sig på din hjemmebane`)
};

const nb_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva som endrer seg på hjemmebanen din`)
};

const fi_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikä muuttuu kotikentälläsi`)
};

const pl_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co zmienia się na Twoim polu`)
};

const ru_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что меняется на вашем домашнем поле`)
};

const tr_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kendi sahanızda neler değişir`)
};

const hi_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके घरेलू कोर्स पर क्या बदलता है`)
};

const id_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang berubah di lapangan golf langganan Anda`)
};

const ms_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang berubah di padang golf tempat anda biasa bermain`)
};

const cs_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co se změní na vašem domovském hřišti`)
};

const el_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τι αλλάζει στο γήπεδο όπου παίζετε συνήθως`)
};

const he_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מה משתנה במגרש הבית שלכם`)
};

const af_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat op jou tuisbaan verander`)
};

const hu_method_content_step_05_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi változik a törzspályádon`)
};

/**
* | output |
* | --- |
* | "What changes at your home course" |
*
* @param {Method_Content_Step_05_Detail_Amateur_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_05_detail_amateur_1_heading = /** @type {((inputs?: Method_Content_Step_05_Detail_Amateur_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_05_Detail_Amateur_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "de") return de_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "th") return th_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "it") return it_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "da") return da_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "id") return id_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "el") return el_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "he") return he_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "af") return af_method_content_step_05_detail_amateur_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_05_detail_amateur_1_heading(inputs)
	return en_method_content_step_05_detail_amateur_1_heading(inputs)
});